/**
 * [GORIDE] GWP カートメッセージ & 確認チェックボックス
 *
 * ■ GWP メッセージ
 *   対象商品がカートにある期間中、Rebuy カート / Palo Alto ドロワーに
 *   メッセージを表示する。
 *
 * ■ 確認チェックボックス（インライン注意ボックス）
 *   チェックアウトボタン直前に常時表示。
 *   チェックなしでチェックアウトしようとすると、
 *   エラー文をボックス内に表示してブロックする（モーダルなし）。
 *
 * ■ 対応カート
 *   - Rebuy カート（#rebuy-cart）: JS で注入・同期
 *   - Palo Alto ドロワー: JS で同期
 *   - カートページ（form[data-cart-form]）: Liquid で事前レンダリング済み
 */

(function () {
  var SECTION_GWP       = 'goride-api-gwp';
  var SECTION_AGREEMENT = 'goride-api-agreement';
  var DEBUG = true;

  /* ─── ユーティリティ ─── */

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[GORIDE GWP]');
    console.log.apply(console, args);
  }

  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function waitForEl(sel, timeout) {
    timeout = timeout || 15000;
    return new Promise(function (resolve, reject) {
      var found = document.querySelector(sel);
      if (found) return resolve(found);
      var obs = new MutationObserver(function () {
        var el = document.querySelector(sel);
        if (el) { obs.disconnect(); resolve(el); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
        reject(new Error('waitForEl timeout: ' + sel));
      }, timeout);
    });
  }

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root : '/';
  }

  /* ─── GWP メッセージ同期 ─── */

  function syncGwpMessage(trigger) {
    log('🔄 syncGwpMessage:', trigger);
    var url = getRoot() + 'cart?section_id=' + SECTION_GWP;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc    = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('[data-goride-gwp-message-holder]');
        document.querySelectorAll('[data-goride-gwp-message-holder]').forEach(function (el) {
          if (source) {
            el.innerHTML = source.innerHTML;
            el.className = source.className;
            el.setAttribute('aria-hidden', source.getAttribute('aria-hidden') || 'false');
          } else {
            el.innerHTML = '';
            el.className = 'goride-gwp-message goride-gwp-message--hidden';
            el.setAttribute('aria-hidden', 'true');
          }
        });
        log('✅ GWP メッセージ更新完了');
      })
      .catch(function (err) { console.warn('[GORIDE GWP] syncGwpMessage 失敗:', err); });
  }

  function createEmptyGwpHolder() {
    var el = document.createElement('div');
    el.setAttribute('data-goride-gwp-message-holder', '');
    el.className = 'goride-gwp-message goride-gwp-message--hidden';
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function ensureRebuyGwpHolder(cartEl) {
    var flyoutContent = cartEl.querySelector('.rebuy-cart__flyout-content');
    if (!flyoutContent) return false;
    if (cartEl.querySelector('[data-goride-gwp-message-holder]')) return true;
    flyoutContent.parentNode.insertBefore(createEmptyGwpHolder(), flyoutContent);
    log('💉 GWP ホルダー注入');
    return true;
  }

  /* ─── 確認チェックボックス（インライン注意ボックス） ─── */

  function createEmptyAgreementHolder() {
    var el = document.createElement('div');
    el.setAttribute('data-goride-gwp-agreement-holder', '');
    el.className = 'goride-gwp-agreement goride-gwp-agreement--hidden';
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  /**
   * Rebuy カートの flyout-actions 内、チェックアウトボタンの直前に
   * 注意ボックス（agreement ホルダー）を注入する。
   */
  function ensureRebuyAgreementHolder(cartEl) {
    var actions = cartEl.querySelector('.rebuy-cart__flyout-actions');
    if (!actions) return false;
    if (cartEl.querySelector('[data-goride-gwp-agreement-holder]')) return true;
    var checkoutBtn = actions.querySelector('.rebuy-cart__checkout-button');
    if (checkoutBtn) {
      actions.insertBefore(createEmptyAgreementHolder(), checkoutBtn);
    } else {
      actions.insertBefore(createEmptyAgreementHolder(), actions.firstChild);
    }
    log('💉 Agreement ホルダー注入');
    return true;
  }

  /**
   * agreement API を fetch して全ホルダーの内容を更新する。
   * Vue 再レンダリング後も呼ばれるため、チェックボックスの checked 状態を保持する。
   */
  function syncAgreement(trigger) {
    log('🔄 syncAgreement:', trigger);
    var url = getRoot() + 'cart?section_id=' + SECTION_AGREEMENT;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc    = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('[data-goride-gwp-agreement-holder]');

        document.querySelectorAll('[data-goride-gwp-agreement-holder]').forEach(function (el) {
          /* チェック状態を保持 */
          var prevChecked = false;
          var prevCb = el.querySelector('[data-goride-gwp-agreement-checkbox]');
          if (prevCb) prevChecked = prevCb.checked;

          if (source) {
            el.innerHTML = source.innerHTML;
            el.className = source.className;
            var errText = source.getAttribute('data-goride-gwp-agreement-error-text');
            if (errText) el.setAttribute('data-goride-gwp-agreement-error-text', errText);
          } else {
            el.innerHTML = '';
            el.className = 'goride-gwp-agreement goride-gwp-agreement--hidden';
            el.setAttribute('aria-hidden', 'true');
          }

          /* チェック状態を復元 */
          if (prevChecked) {
            var newCb = el.querySelector('[data-goride-gwp-agreement-checkbox]');
            if (newCb) newCb.checked = true;
          }
        });

        /* カートが開かれてから SCROLL_RESET_WINDOW ms 以内なら
           スクロールを先頭にリセットする（Rebuy / iOS が動かしても上書き）。 */
        if (Date.now() - lastCartOpenTime < SCROLL_RESET_WINDOW) {
          var actions = document.querySelector('#rebuy-cart .rebuy-cart__flyout-actions');
          if (actions) {
            log('📜 scrollTop before reset:', actions.scrollTop);
            actions.scrollTop = 0;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                var a = document.querySelector('#rebuy-cart .rebuy-cart__flyout-actions');
                if (a) {
                  log('📜 scrollTop after double-rAF:', a.scrollTop);
                  a.scrollTop = 0;
                  /* さらに 200ms 後にも確認（Rebuy が遅延スクロールする場合） */
                  setTimeout(function() {
                    var b = document.querySelector('#rebuy-cart .rebuy-cart__flyout-actions');
                    if (b) {
                      log('📜 scrollTop after 200ms:', b.scrollTop);
                      if (Date.now() - lastCartOpenTime < SCROLL_RESET_WINDOW) b.scrollTop = 0;
                    }
                  }, 200);
                }
              });
            });
          }
        }

        log('✅ Agreement 更新完了');
      })
      .catch(function (err) { console.warn('[GORIDE GWP] syncAgreement 失敗:', err); });
  }

  /* ─── チェックアウトガード ─── */

  /**
   * 注意ボックスが表示されているかどうかを確認する。
   * （条件に合致してボックスが visible になっている）
   */
  function isAgreementVisible() {
    var holder = document.querySelector('[data-goride-gwp-agreement-holder]');
    return holder && !holder.classList.contains('goride-gwp-agreement--hidden');
  }

  /**
   * チェックボックスがチェック済みかどうかを確認する。
   */
  function isAgreementChecked() {
    var cb = document.querySelector('[data-goride-gwp-agreement-checkbox]:not(:disabled)');
    return cb && cb.checked;
  }

  /**
   * エラーメッセージを表示してボックスまでスクロールする。
   */
  function showAgreementError() {
    var holder = document.querySelector('[data-goride-gwp-agreement-holder]:not(.goride-gwp-agreement--hidden)');
    if (!holder) return;
    var errText = holder.getAttribute('data-goride-gwp-agreement-error-text')
               || 'チェックアウトの前に上記内容をご確認ください';
    var errorEl = holder.querySelector('[data-goride-gwp-agreement-error]');
    if (errorEl) {
      errorEl.textContent = errText;
    }
    /* チェックボックスが見えるまでスクロール */
    holder.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    log('⚠️ Agreement エラー表示');
  }

  function clearAgreementError() {
    document.querySelectorAll('[data-goride-gwp-agreement-error]').forEach(function (el) {
      el.textContent = '';
    });
  }

  /* ─── Rebuy カートのチェックアウトブロック ─── */

  function setupRebuyCheckoutBlock(cartEl) {
    var actions = cartEl.querySelector('.rebuy-cart__flyout-actions');
    if (!actions || actions._goride_agreement_block) return;
    actions._goride_agreement_block = true;

    actions.addEventListener('click', function (e) {
      var btn = e.target.closest('.rebuy-cart__checkout-button');
      if (!btn) return;

      /* 注意ボックスが表示されていない場合はスルー */
      if (!isAgreementVisible()) return;

      /* チェック済みならスルー */
      if (isAgreementChecked()) { clearAgreementError(); return; }

      /* ブロック + エラー表示 */
      e.preventDefault();
      e.stopImmediatePropagation();
      showAgreementError();
    }, true /* Vue のハンドラより先に capture で発火 */);

    log('🔒 Rebuy チェックアウトブロック設置');
  }

  /* ─── カートページのチェックアウトブロック ─── */

  function setupCartPageBlock() {
    var form = document.querySelector('form[data-cart-form]');
    if (!form || form._goride_agreement_block) return;
    form._goride_agreement_block = true;

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name !== 'checkout') return;
      if (!isAgreementVisible()) return;
      if (isAgreementChecked()) { clearAgreementError(); return; }

      e.preventDefault();
      showAgreementError();
    });

    log('🔒 カートページ チェックアウトブロック設置');
  }

  /* ─── Rebuy カートモード ─── */

  /* カートが最後に開かれた時刻（ms）。
     この時刻から SCROLL_RESET_WINDOW ms 以内に完了した syncAgreement は
     すべてスクロールをリセットする（Vue の再描画タイミングのずれに対応）。 */
  var lastCartOpenTime = 0;
  var SCROLL_RESET_WINDOW = 2000;

  function handleRebuySync(cartEl, trigger) {
    /* GWP メッセージ — 一時非表示
    ensureRebuyGwpHolder(cartEl);
    syncGwpMessage(trigger);
    */
    ensureRebuyAgreementHolder(cartEl);
    syncAgreement(trigger);
    setupRebuyCheckoutBlock(cartEl);
  }

  function initRebuyCart() {
    log('⏳ #rebuy-cart 待機中...');
    waitForEl('#rebuy-cart').then(function (cartEl) {
      log('✅ #rebuy-cart 検出');

      /* カートが開いたとき */
      var classObs = new MutationObserver(function () {
        if (cartEl.classList.contains('is-visible')) {
          log('🛒 Rebuy カート開いた');
          lastCartOpenTime = Date.now(); /* 開いた時刻を記録 */
          handleRebuySync(cartEl, 'is-visible');
        }
      });
      classObs.observe(cartEl, { attributes: true, attributeFilter: ['class'] });

      /* Vue 再レンダリング時（ホルダーが消えた場合のみ再注入）
         ※ GWP メッセージは一時非表示のため gwpMissing は常に true になる。
            agreementMissing のみを判定し、無限ループを防ぐ。 */
      var rerenderObs = new MutationObserver(debounce(function () {
        if (!cartEl.classList.contains('is-visible')) return;
        var agreementMissing = !cartEl.querySelector('[data-goride-gwp-agreement-holder]');
        if (agreementMissing) {
          log('🔁 Vue 再レンダリング → 再注入');
          handleRebuySync(cartEl, 're-render');
        }
      }, 150));
      rerenderObs.observe(cartEl, { childList: true, subtree: true });

      if (cartEl.classList.contains('is-visible')) {
        lastCartOpenTime = Date.now();
        handleRebuySync(cartEl, 'initial');
      }
    }).catch(function (err) { log('⚠️ waitForEl 失敗:', err.message); });
  }

  /* ─── Palo Alto ドロワーモード（フォールバック） ─── */

  function initPaloAltoDrawer() {
    var drawerEl = document.querySelector('[data-cart-drawer]');
    log('🔍 Palo Alto [data-cart-drawer]:', drawerEl ? '存在する' : '存在しない');
    if (!drawerEl) return false;

    var mutObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          if (document.querySelector('[data-goride-gwp-message-holder]')) {
            syncGwpMessage('PaloAlto');
            syncAgreement('PaloAlto');
          }
        }
      });
    });
    mutObs.observe(drawerEl, { childList: true });

    document.addEventListener('theme:cart:loaded', function () {
      syncGwpMessage('theme:cart:loaded');
      syncAgreement('theme:cart:loaded');
    });
    document.addEventListener('theme:cart:added', function () {
      syncGwpMessage('theme:cart:added');
      syncAgreement('theme:cart:added');
    });

    return true;
  }

  /* ─── 初期化 ─── */

  log('✅ goride-gwp.js ロード完了');

  initPaloAltoDrawer();
  initRebuyCart();
  setupCartPageBlock();

})();
